export default {
  name: 'my-approval',
  translationKey: 'my-approval-module',
  routePrefix: 'my-approval',
  routeNamePrefix: 'my-approval',
  directRoutesAvailable: true,
}
